import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { faLongArrowRight, faExclamationCircle, faEye, faEyeSlash, faThumbsDown } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent {

    mail: string;
    pass: string;
    passConf: string;
    data: any = {
        name: null,
        phone: null,
        zipcity: null,
        streetnumber: null,
        cid: null,
    }
    error: string;
    passType: string = "password";
    validMail: boolean = null;
    validPass: boolean = null;
    validConf: boolean = null;

    constructor(private auth: AuthService) {}

    register(e) {
        e.preventDefault();
        if(this.validMail && this.validPass && this.validConf && this.data.name && this.data.phone && this.data.zipcity && this.data.streetnumber) {
            this.error = null;
            this.auth.signup(this.mail, this.pass, this.data);
        } else {
            if(!this.validMail) { this.validateMail(); }
            if(!this.validPass) { this.validatePass(); }
            if(!this.validConf) { this.validateConf(); }
            if(this.validConf && this.validPass && this.validMail) {
                this.error = 'Bitte füllen Sie alle Pflichtfelder aus.';
            }
        }
    }

    validateMail() {
        if(this.mail != null) {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.mail)) {
                this.error = null;
                return this.validMail = true;
            } else {
                this.error = 'Bitte geben Sie eine valide E-Mail Adresse ein.';
                return this.validMail = false;
            }
        } else {
            this.error = 'Bitte füllen Sie alle Pflichtfelder aus.';
            return this.validMail = false;
        }
    }

    validatePass() {
        if(this.pass != null) {
            if (/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/.test(this.pass)) {
                this.error = null;
                return this.validPass = true;
            } else {
                this.error = 'Bitte geben Sie eine Passwort mit min. 8 Zeichen ein, welches sowohl Groß-, Kleinbuchstaben und Ziffern besitzt.';
                return this.validPass = false;
            }
        } else {
            this.error = 'Bitte füllen Sie alle Pflichtfelder aus.';
            return this.validPass = false;
        }
    }
  
    validateConf() {
        if(this.passConf != null) {
            if(this.pass == this.passConf) {
                this.error = null;
                return this.validConf = true;
            } else {
                this.error = 'Die beiden Passwörter stimmen nicht überein.';
                return this.validConf = false;
            }
        } else {
            this.error = 'Bitte füllen Sie alle Pflichtfelder aus.';
            return this.validConf = false;
        }
    }

    toggleVisability() {
        if(this.passType == "password") {
            this.passType = "text";
        } else {
            this.passType = "password";
        }
    }

    longArrowRight = faLongArrowRight;
    exclamationCircle = faExclamationCircle;
    eye = faEye;
    eyeSlash = faEyeSlash;
}
